import { defineSagaForService, DownloadQueriesSagasFactory, QueriesSagasFactory } from '@repo/core'
import { all, takeLatest } from 'redux-saga/effects'
import {
  aliasActions,
  bankingProductLoanReceiptsDataActions,
  bankingProductMovementsDataActions,
  productOperationsMasterListActions,
} from '../store/actions'
import {
  editAlias,
  fileDownloadConfig as fileDownloadConfigDetail,
  serviceConfig as serviceConfigDetail,
} from './detail'
import { serviceConfig as serviceConfigList } from './list'
import {
  bankingProductLoanReceiptsDownloadConfig,
  bankingProductMovementsDownloadConfig,
  loadProductOperationsByFilters,
  productOperationsDownloadConfig,
  serviceConfig as serviceConfigMaster,
} from './master'
import { loadBankingProductLoanReceiptsByFilters } from './master/list/bankingProductLoanReceipts'
import { loadBankingProductMovementsByFilters } from './master/list/bankingProductMovements'
import { watchAccountsNotifications } from './notifications'

const serviceConfig = defineSagaForService({
  ...serviceConfigDetail,
  ...serviceConfigList,
  ...serviceConfigMaster,
})

const fileDownloadConfig = {
  ...fileDownloadConfigDetail,
  ...productOperationsDownloadConfig,
  ...bankingProductMovementsDownloadConfig,
  ...bankingProductLoanReceiptsDownloadConfig,
}

const serviceSagas = Object.keys(serviceConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, QueriesSagasFactory(serviceConfig, actionTypeRequest)),
)

const fileDownloadSagas = Object.keys(fileDownloadConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, DownloadQueriesSagasFactory(fileDownloadConfig, actionTypeRequest)),
)

export function* rootAccountsSaga() {
  yield all([
    ...serviceSagas,
    ...fileDownloadSagas,
    takeLatest(aliasActions.saveEditAlias.type, editAlias),
    watchAccountsNotifications(),
    takeLatest(
      productOperationsMasterListActions.getRequestByFilters.type,
      loadProductOperationsByFilters,
    ),
    takeLatest(
      bankingProductMovementsDataActions.getRequestByFilters.type,
      loadBankingProductMovementsByFilters,
    ),
    takeLatest(
      bankingProductLoanReceiptsDataActions.getRequestByFilters.type,
      loadBankingProductLoanReceiptsByFilters,
    ),
  ])
}
